import React from 'react';

const IntegrationsIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.91571 8.96094H12.0841C12.5445 8.96094 12.9178 9.33419 12.9178 9.79462V10.8367C12.9178 11.8727 12.078 12.7125 11.042 12.7125H8.95781C7.92185 12.7125 7.08203 11.8727 7.08203 10.8367V9.79462C7.08203 9.33419 7.45528 8.96094 7.91571 8.96094Z"
      stroke={props.color || '#000000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.36215 8.95781V7.08203"
      stroke={props.color || '#000000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6356 8.95781V7.08203"
      stroke={props.color || '#000000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3339 16.7121C16.6445 15.0651 18.2602 11.2508 17.1399 7.72705C16.0197 4.2033 12.4979 2.02224 8.84412 2.58939C5.19034 3.15654 2.49545 6.30256 2.4961 10.0001C2.49434 12.0718 3.3175 14.0589 4.78372 15.5224V15.5224C5.87475 16.6093 7.35203 17.2198 8.8921 17.2198V17.2198C9.50336 17.2193 9.99876 16.7239 9.99922 16.1126V12.7096"
      stroke={props.color || '#000000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IntegrationsIcon;
